module.exports = __webpack_public_path__ + "static/media/privacypolicy_english.8f2e0d56.md";